"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "santarcangelo-di-romagna": {
    "7651780d": [{
      "hkey": "ea24e289",
      "slug": "santa-giustina-casale-san-vito",
      "name": "Santa Giustina-Casale San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "casale-di-san-vito": [{
      "hkey": "ea24e289",
      "slug": "santa-giustina-casale-san-vito",
      "name": "Santa Giustina-Casale San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "482ff1f2": [{
      "hkey": "fe301e00",
      "slug": "sant-ermete",
      "name": "Sant'Ermete",
      "primary": true,
      "skipSearch": false
    }],
    "casale-sant-ermete": [{
      "hkey": "fe301e00",
      "slug": "sant-ermete",
      "name": "Sant'Ermete",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b4ac5193": [{
      "hkey": "ea24e289",
      "slug": "santa-giustina-casale-san-vito",
      "name": "Santa Giustina-Casale San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "casale-san-vito-santa-giustina": [{
      "hkey": "ea24e289",
      "slug": "santa-giustina-casale-san-vito",
      "name": "Santa Giustina-Casale San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;